import axios from "axios";
import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import OptionalOption from "../../components/FilterComponents/OptionalOption";
import useAuth from "../../hooks/useAuth";
import { BASE_URL } from "../../utils/Element";

const statusOptions = [
  { value: "", label: "All Status" },
  { value: "attempt", label: "Attempt" },
  { value: "success", label: "Success" },
  { value: "failure", label: "Failure" },
];

const tabOptions = [
  { value: "all", label: "All Tabs" },
  { value: "exports", label: "Export History" },
  { value: "login-frequency", label: "Login Frequency" },
  { value: "module-frequency", label: "Module Frequency" },
];

const SystemAlertsFilterData = ({ isSidebarOpen, filterData, onSetFilterData }) => {
  const [config] = useAuth();
  const [userOptions, setUserOptions] = useState([]);

  const handleFilterChange = (value, key) => {
    onSetFilterData({ ...filterData, [key]: value });
  };

  const fetchUsers = () => {
    axios
      .get(`${BASE_URL}/get-datalisting?list=users`, config)
      .then((res) => {
        const data = res?.data?.data || [];
        const options = data.map((el) => ({
          value: el?.id,
          label: `${el?.first_name || ""} ${el?.last_name || ""}`.trim(),
        }));
        setUserOptions(options);
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  useEffect(() => {
    if (isSidebarOpen) {
      fetchUsers();
    }
  }, [isSidebarOpen]);

  return (
    <div>
      <div className="mt-4">
        <label className="dark-H head-4 mb-2">User</label>
        <Select
          className="body-S"
          placeholder="All Users"
          value={userOptions?.find((el) => el?.value === filterData?.userId) || null}
          options={userOptions}
          isClearable
          onChange={(option) => {
            handleFilterChange(option?.value || "", "userId");
          }}
        />
      </div>

      <div className="mt-4">
        <label className="dark-H head-4 mb-2">Tab</label>
        <Select
          className="body-S"
          value={tabOptions.find((el) => el.value === filterData?.tab) || tabOptions[0]}
          options={tabOptions}
          onChange={(option) => handleFilterChange(option?.value || "all", "tab")}
        />
      </div>

      <div className="mt-4">
        <label className="dark-H head-4 mb-2">Status</label>
        <Select
          className="body-S"
          value={statusOptions.find((el) => el.value === filterData?.status) || statusOptions[0]}
          options={statusOptions}
          onChange={(option) => handleFilterChange(option?.value || "", "status")}
        />
      </div>

      <div className="mt-4">
        <label className="dark-H head-4 mb-2">Module</label>
        <input
          type="text"
          className="body-S"
          placeholder="dashboard"
          value={filterData?.module || ""}
          onChange={(e) => handleFilterChange(e.target.value, "module")}
        />
      </div>

      <hr className="my-6" style={{ borderColor: "#6F6F6F" }} />

      <div>
        <p className="head-4 dark-H capitalize">Timeframe</p>
        <OptionalOption
          activeTab="date"
          onSetLastDate={(value) => handleFilterChange(value, "singleDate")}
          date={filterData?.singleDate}
          onSetDateRange1={(value) => handleFilterChange(value, "fromDate")}
          date2={filterData?.fromDate}
          onSetDateRange2={(value) => handleFilterChange(value, "toDate")}
          date3={filterData?.toDate}
          onClear={() => {
            onSetFilterData({
              ...filterData,
              singleDate: "",
              fromDate: "",
              toDate: "",
            });
          }}
        />
      </div>
    </div>
  );
};

export default SystemAlertsFilterData;
